import { render, staticRenderFns } from "./ProspectHeader.vue?vue&type=template&id=814fcf60&"
import script from "./ProspectHeader.vue?vue&type=script&lang=js&"
export * from "./ProspectHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports